module.exports = __webpack_public_path__ + "static/media/BlackBurger.4bb99641.svg";